window.BriefCasePoup = {
	init: function (linkedtype, linkedid) {

		var options = {
			title: Loc.g('Voir les fichiers attachés'),
			width: 800,
			buttons: [
				{
					text: Loc.g("Fermer"), click: function () {
						$(this).dialog("close");
					}
				}],
			callback: function () {
				BriefCaseV2Light.init();
			}

		};

		MyWindow.load("briefcasev2", { action: "lightBriefcasePopup", 'linkedtype': linkedtype, 'linkedid': linkedid }, options);

	}
}


window.BriefCaseV2Light = {

	init: function () {
		BriefCaseV2Light.initDragNDrop();
		$('.briefcase-toggler-close:first').trigger('click');
	},

	initDragNDrop: function () {

		Qtip.init();

		$(".one-draggable").draggable({
			revert: true,
			helper: "clone"
		});

		$(".one-droppable").droppable({
			hoverClass: "ui-droppable-drophover", drop: function (event, ui) {

				var dropDirId = $(this).parent().attr('id');

				if (ui.draggable.hasClass('one-droppable')) {
					var dragDirId = ui.draggable.parent().attr('id');
				} else {
					var dragDirId = ui.draggable.attr('id');
				}

				if ($('#briefcasev2light, #briefcasev2Tab').find('.structure #' + dragDirId).find('#' + dropDirId).length > 0) {

					MyWindow.alert(Loc.g("Vous ne pouvez pas déplacer un dossier dans un de ses sous dossiers"), { 'type': 'error' });

				} else {

					var options = {
						resizable: false,
						noclose: true,
						title: Loc.g("Attention!"),
						type: "warning",
						buttons: [
                            { text: Loc.g("Annuler"), click: function () { $(this).dialog("close"); return; } },
							{
								text: Loc.g("Déplacer"), click: function () {
									$(this).dialog("close");

									MyFacture.post('briefcasev2', { action: 'dirManagement', ressourceToManage: dragDirId, ressourceTo: dropDirId, todo: 'move' }, function (data) {
										if (data.success == "Y") {

											if ($('#' + dropDirId).hasClass('open')) {
												$('#' + dragDirId).appendTo('#' + dropDirId + ' .sub:first ul:first');
											} else {
												$('#' + dragDirId).remove();
											}

										} else {
											MyWindow.alert(data.error, { type: 'error' })
										}
									}, 'json');

									return;
								}
							},
						]
					};
					MyWindow.alert(Loc.g("Déplacer la ressource ?"), options);

				}

			}
		});

	},

	toggleDir: function (dirId, dirType, dirRelatedId) {

		var curDir = $('#briefcasev2light, #briefcasev2Tab').find('#folder_' + dirId);

		if (curDir.hasClass('open')) {
			curDir.find('.briefcase-toggler-close').first().removeClass('briefcase-toggler-open');
			curDir.removeClass('open');
			curDir.find('.sub').first().slideUp();
		} else {
			BriefCaseV2Light.openDir(dirId, dirType, dirRelatedId);
			curDir.addClass('open');
			curDir.find('.briefcase-toggler-close').first().addClass('briefcase-toggler-open');
		}

	},

	openDir: function (dirId, dirType, dirRelatedId) {

		var curDir = $('#briefcasev2light, #briefcasev2Tab').find('#folder_' + dirId);
		var params = { dirid: dirId, dirType: dirType, dirRelatedId: dirRelatedId, action: 'openLightDir' };

		MyFacture.post('briefcasev2', params, function (data) {
			curDir.find('.sub').first().html(data.briefcaselight_structure).slideDown();
			curDir.addClass('alreadyOpenned');
			BriefCaseV2Light.initDragNDrop();
		}, 'json');

	},

	addIt: function (data) {
		if (data.success) {
			var newLine = '<li id="file_' + data.file_infos.file_id + '" class="lightbf_row one-draggable" type="file">'
				+ '<a href="javascript:;" tips="' + Loc.g('Bouton glisser-déposer pour organiser vos fichiers') + '" positiontips="left">'
				+ '<i class="fa fa-arrows fa-15" style="margin-right:15px;"></i>'
				+ '</a>'
				+ '<img src="/ressources/logged/img/classeur/' + data.file_infos.extension + '.png"/>\n'
				+ '	<a target="_blank" href="' + data.public_path + '" title="' + data.file_infos.file_fullname + '">'
				+ data.file_infos.file_fullname
				+ '	</a>'
				+ '	<a href="javascript:;" onclick="BriefCaseV2Light.deleteIt(' + data.file_infos.file_id + ')" class="deleteLinkedDoc"></a>'
				+ '</li>';
			$('#briefcasev2light, #briefcasev2Tab').find('.structure .lightbf_lvl').first().append(newLine);
			$('#nodoc').remove();
			BriefCaseV2Light.initDragNDrop();
			MyFacture.customForm();
		}
	},

	deleteIt: function (fid) {

		return new Promise((resolve, reject) => {

			var options = {
				resizable: false,
				noclose: true,
				title: Loc.g("Attention!"),
				type: "warning",
				buttons: [
					{
						text: Loc.g("Non"),
						click: function () {
							$(this).dialog("close");
							reject();
							return false;
						}
					}, {
						text: Loc.g("Oui"),
						click: function () {
							$(this).dialog("close");

							var datas = {
								action: "deletefile",
								fid: fid
							};

							MyFacture.post("uploadFile", datas, function (data) {
								if (data.filedelid) {
									$('#file_' + data.filedelid).remove();
									resolve(data);
								} else {
									Push.error(Loc.g("Le fichier n'est pas accessible"));
								}
                            }, "json");

                        }
                    }
                ]
            };

            MyWindow.alert(Loc.g("Supprimer le fichier ?"), options);
        });
	},

	downloadArchive(method, url, data)
	{
		$.ajax({
			type: method,
			url: url,
			data: data,
			success: function (reponse) {
				MyWindow.alert(Loc.g("Nous sommes en train de générer le fichier d'export.  Vous recevrez un email avec un lien de téléchargement lorsque le fichier sera prêt"), { type: 'success' });
			},
			error: function (response) {
				if (response.status == 400 && response.responseJSON.error) {
					MyWindow.alert(response.responseJSON.error.message, { type: 'error' });
				} else {
					MyWindow.alert(Loc.g("Une erreur est survenue, veuillez ré-essayer ultérieurement."), { type: 'error' });
				}
			},
			dataType: 'json'
		});
	},

	downloadLinkedDocs: function(linkedtype, linkedid){
		this.downloadArchive('GET', '/?_f=uploadFile&action=downloadlinked&linkedtype='+linkedtype+'&linkedid='+linkedid, {});
	},

	createDir: function(parentid){
		var options = {
			dialogClass: "white",
			title: Loc.g("Créer un dossier"),
			buttons: [
				{ text: Loc.g("Annuler"), click: function () { $(this).dialog("close"); } },
				{ text: Loc.g("Créer"), click: function () { $("#createDirForm").submit(); } }
			],
			callback: function () { BriefCaseV2Light.preapreCreateDir(); }

		};
		MyWindow.load("briefcasev2", { action: "createDirForm", parentid: parentid }, options);
	},

	editDir: function (dirId) {
		var options = {
			title: Loc.g("Modifier le dossier"),
			buttons: [
				{ text: Loc.g("Annuler"), click: function () { $(this).dialog("close"); } },
				{ text: Loc.g("Modifier"), click: function () { $("#createDirForm").submit(); } }
			],
			callback: function () { BriefCaseV2Light.preapreCreateDir(); }

		};
		MyWindow.load("briefcasev2", { action: "createDirForm", dirId: dirId }, options);
	},

	preapreCreateDir: function () {
		var formId = "createDirForm";
		var options = { success: function (data) { BriefCaseV2Light.createDirCallback(data); }, dataType: "json" };
		var params = { 'action': 'createDir' };
		MyForm.prepare(formId, 'briefcasev2&' + $.param(params), options, true);
		$("#createDir_privilege").change(function () {
			if ($(this).find('option:selected').val() == "custom") {
				$("#createDirForm .collab-container").fadeIn();
			} else {
				$("#createDirForm .collab-container").fadeOut();
			}
		});
		MyFacture.initEvent();
	},

	createDirCallback: function (data) {

		var formIsOk = MyForm.processJson(data, "createDirForm");
		if (formIsOk) {
			if (data.succes == 'Y') {
				switch (data.type) {
					case "create":
						if ($('#folder_' + data.folder_new.parentid).hasClass('open')) {
							var html = '<li id="folder_' + data.folder_new.id + '" class="lightbf_row" type="folder">'
								+ '<div class="one-droppable one-draggable">'
								+ '<a href="javascript:;" class="" tips="Bouton glisser-déposer pour organiser vos fichiers" positiontips="left"><i class="fa fa-arrows" style="margin-right: 15px;"></i></a>'
								+ '<a href="javascript:;" onClick="BriefCaseV2Light.toggleDir(' + data.folder_new.id + ')" class="briefcase-toggler-close"></a>'
								+ '<img src="/ressources/logged/img/classeur/folder.png" alt="' + data.folder_new.name + '" />'
								+ '<a href="javascript:;" class="structure-item-name">' + data.folder_new.name + '</a>'
								+ '<div class="one-item-action-container">'
								+ '<a tips="' + Loc.g('Modifier le dossier') + '" class="one-item-action-folder folder-edit mr-2" href="javascript:;" onClick="BriefCaseV2Light.editDir(' + data.folder_new.id + ')"><i class="fa icon-edit fa-gray fa-15"></i></a>'
								+ '<a tips="' + Loc.g('Supprimer le dossier') + '" class="one-item-action-folder folder-delete" href="javascript:;" onClick="BriefCaseV2Light.deleteFolder(' + data.folder_new.id + ')"><i class="fa icon-trash fa-gray fa-15"></i></a>'
								+ '</div>'
								+ '</div>'
								+ '<div class="sub hidden"></div>'
								+ '</li>';

							$('#folder_' + data.folder_new.parentid + ' .sub:first ul:first').append(html);
							BriefCaseV2Light.initDragNDrop();
						}
						break;
					case "edit":
						var editObj = data.folder_edit;
						$('#briefcasev2light, #briefcasev2Tab').find('#folder_' + editObj.id + " .structure-item-name").html(editObj.name);
						break;
				}
			} else if (data.isAccessible === 'N') {
				Push.error(Loc.g("Vous n'avez pas les permissions requises."));
			} else {
				MyWindow.alert(Loc.g("Un dossier portant ce nom existe déjà. Veuillez choisir un autre nom."), { 'type': 'error' });
			}
			MyWindow.close();
		}
	},

	deleteFolder: function (dirIr) {
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Attention!"),
			type: "warning",
			buttons: [
				{ text: Loc.g("Non"), click: function () { $(this).dialog("close"); return false; } },
				{ text: Loc.g("Oui"), click: function () { BriefCaseV2Light.deleteFolderCallback(dirIr); $(this).dialog("close"); } }
			]
		};
		MyWindow.alert(Loc.g("Supprimer le dossier ?"), options);
	},

	deleteFolderCallback: function (dirid) {
		var params = new Object;
		params.dirid = dirid;
		params.action = 'deleteFolder';
		MyFacture.post('briefcasev2', params, function (data) {
			if (data.success === 'N') {
				Push.error(Loc.g("Le dossier n'est pas accessible"));
			} else {
				$('#briefcasev2light, #briefcasev2Tab').find('#folder_' + dirid).remove();
			}
		}, 'json');
	}

};



window.BriefCaseV2 = {

	attachFileTo: function (attachToType, fileId, me) {
		var todo = "detachFile";
		if (me.is(':checked')) {
			todo = 'attachFile';
		}
		var params = new Object;
		params.fileid = fileId;
		params.attachTo = attachToType;
		params.action = 'attachDetachFile';
		params.todo = todo;
		MyFacture.post('briefcasev2', params, function (data) {
			if (data.success === 'N') {
				Push.error(Loc.g("Le fichier n'est pas accessible"));
			}
		}, 'json');
	},

	toggleCheckboxes: function () {
		if ($('#briefcase .grouped-action-selector-all input').is(':checked')) {
			$('#briefcase .grouped-action-selector input[type=checkbox]:visible').prop('checked', true);
		} else {
			$('#briefcase .grouped-action-selector input[type=checkbox]').prop('checked', false);
		}
	},

	showAction: function (me) {
		var toToggle = me.parent().find('.one-item-action-container');

		toToggle.slideToggle('fast');
		$('#briefcase .current-container .one-item .one-item-action-container').not(toToggle).slideUp('fast');
	},

	initDragAndDrop: function () {
		$(".one-draggable").closest('.content-to-drag').draggable({ revert: true, helper: "clone", handle: ".one-draggable" });
		$(".one-droppable").droppable({
			hoverClass: "ui-droppable-drophover", drop: function (event, ui) {
				var dropDirId = $(this).find('[id^="folder_"]').attr('id');
				var dragType = ui.draggable.attr('type');
				var dragDirId = ui.draggable.find('[id^="' + dragType + '_"]').attr('id');
				if ($('#briefcase .structure-container #' + dragDirId).closest('.structure-folder').find('#' + dropDirId).length == 1) {
					MyWindow.alert(Loc.g("Vous ne pouvez pas déplacer un dossier dans un de ses sous dossiers"), { 'type': 'error' });
				} else {
					var options = {
						resizable: false,
						noclose: true,
						title: Loc.g("Attention!"),
						type: "warning",
						buttons: [
                            { text: Loc.g("Annuler"), click: function () { $(this).dialog("close"); return false; } },
                            { text: Loc.g("Déplacer"), click: function () { BriefCaseV2.dirManagement("move", dragDirId, dropDirId); $(this).dialog("close"); } }
						]
					};
					MyWindow.alert(Loc.g("Déplacer la ressource ?"), options);
				}
			}
		});
	},

	slideStructure: function (dirId, onlyOpen) {
		if (onlyOpen) {
			$('.structure-container #folder_' + dirId).parent().find('.briefcase-toggler-close').addClass('briefcase-toggler-open');
			$('.structure-container #folder_' + dirId).parent().next().slideDown();
		} else {
			if (!$('.structure-container #folder_' + dirId).hasClass('already-opened')) {
				BriefCaseV2.openDir(dirId);
			} else {
				$('.structure-container #folder_' + dirId).parent().find('.briefcase-toggler-close').toggleClass('briefcase-toggler-open');
				$('.structure-container #folder_' + dirId).parent().next().slideToggle();
			}
		}
	},

	groupedAction: function () {
		var todo = $('#cur-dir-grouped-action-selector option:selected').val();
		if ((todo != "nothing") && ($('#briefcase .current-container .group-select-folder:checked').length == 0) && ($('#briefcase .current-container .group-select-file:checked').length == 0)) {
			MyWindow.alert(Loc.g('Aucune sélection'), { type: 'error' });
			return;
		}
		var message;
		switch (todo) {
			case "massdelete":
				message = Loc.g("Supprimer l'ensemble des objets sélectionnés") + " ?";
				break;
			case "downloadzip":
				message = Loc.g("Télécharger l'ensemble des objets sélectionnés") + " ?";
				break;
			case "dropboxsync":
				message = Loc.g("Envoyer l'ensemble des objets sélectionnés sur Dropbox") + " ?";
				break;
			default:
				return;
				break;
		}
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Confirmation"),
			type: "warning",
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				}, {
					text: Loc.g("Valider"),
					click: function () {
						$(this).dialog("close");
						BriefCaseV2.groupedActionRequest();
					}
				}
			]
		};
		MyWindow.alert(message, options);
	},

	groupedActionRequest: function () {
		var todo = $('#cur-dir-grouped-action-selector option:selected').val();
		var groupedSelector = {};
		groupedSelector['folders'] = $('#briefcase .current-container .group-select-folder:checked').map(function () { return this.id.replace('group-folder-', ''); }).get();
		groupedSelector['files'] = $('#briefcase .current-container .group-select-file:checked').map(function () { return this.id.replace('group-file-', ''); }).get();
		switch (todo) {
			case "massdelete":
				var params = new Object();
				params.action = "groupedAction";
				params.todo = todo;
				params.ressources = groupedSelector;
				MyFacture.post('briefcasev2', params, function (data) {
					if (data.isAccessible === 'N') {
						Push.error(Loc.g("La ressource n'est pas accessible"));
					} else {
						$('#briefcase .current-container [class^=group-select]:checked').closest('.one-item').remove();
					}
				});
				break;
			case "downloadzip":

				var ressources = groupedSelector;

				BriefCaseV2Light.downloadArchive(
					'POST',
					'/?_f=briefcasev2',
					{
						action		: 'groupedAction',
						todo		: todo,
						ressources	: ressources
					}
				);
				break;
			case "dropboxsync":
				if ($('#dropboxIsConnected').length > 0 && $('#dropboxIsConnected').val() !== 'connected') {
					Dropbox.loadPrefs();
				} else {
					var win = MyWindow.alert(Loc.g("Synchronisation dropbox en cours !") + "<br />" + Loc.g("L'opération peut prendre quelques minutes en fonction du nombre de fichier a synchroniser") + "<br /><img src='/ressources/logged/img/common/loader.gif' style='margin: 10px 42%;'> <br />", { type: 'warning' });
					var params = new Object();
					params.action = "groupedAction";
					params.todo = todo;
					params.ressources = groupedSelector;
					MyFacture.post('briefcasev2', params, function (data) {
						if (data.dropboxerrors !== undefined && data.dropboxerrors.errorDropbox) {
							MyWindow.alert(data.dropboxerrors.errorDropbox, { type: 'error' });
						} else if (data.isAccessible === 'N') {
							MyWindow.alert(Loc.g("La ressource n'est pas accessible"), { type: 'error' });
						} else {
							MyWindow.alert(Loc.g("Synchronisation dropbox réussie !"), { type: 'confirm' });
						}
					});
				}
				break;
		}

	},

	dirManagement: function (action, ressourceId, actionDirIdTo) {
		var params = new Object;
		params.action = 'dirManagement';
		params.ressourceToManage = ressourceId;
		params.ressourceTo = actionDirIdTo;
		params.todo = action;
		MyFacture.post('briefcasev2', params, function (data) {
			if (data.success == "Y") {
				$('#briefcase .current-container').find('#' + ressourceId).closest('.one-item').fadeOut();
				var currentDirArray = $('.cur_dir').attr('id').split('_');
				var toStructure = $('.structure-container #' + actionDirIdTo).closest('.structure-folder');
				var fromStructure = $('.structure-container #' + ressourceId).closest('.structure-folder');
				if (toStructure.find('.structure-folders').length == 0) {
					toStructure.find('.spacer').removeClass('spacer').addClass('briefcase-toggler-close');
					toStructure.find('.structure-folder-title').after('<ul class="structure-folders" style="margin-left: 7px; display: block;"></ul>');
				}
				$('.structure-container #' + actionDirIdTo).parent().next().append(fromStructure);
				BriefCaseV2.openDir(currentDirArray[2]);
				BriefCaseV2.initDragAndDrop();
			} else if (data.isAccessible === 'N') {
				Push.error(Loc.g("La ressource n'est pas accessible"));
			} else {
				MyWindow.alert(data.error, { type: 'error' })
			}
		}, 'json');
	},

	deleteFolder: function (dirIr) {
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Attention!"),
			type: "warning",
			buttons: [
				{ text: Loc.g("Non"), click: function () { $(this).dialog("close"); return false; } },
				{ text: Loc.g("Oui"), click: function () { BriefCaseV2.deleteFolderCallback(dirIr); $(this).dialog("close"); } }
			]
		};
		MyWindow.alert(Loc.g("Supprimer le dossier ?"), options);
	},

	deleteFolderCallback: function (dirid) {
		var params = new Object;
		params.dirid = dirid;
		params.action = 'deleteFolder';
		MyFacture.post('briefcasev2', params, function (data) {
			if (data.success === 'N') {
				Push.error(Loc.g("Le dossier n'est pas accessible"));
			} else {
				$('#briefcase .current-container #folder_' + dirid).closest('.one-item').slideUp('fast').remove();
				$('#briefcase .structure-container #folder_' + dirid).closest('.structure-folder').slideUp('fast').remove();
			}
		}, 'json');
	},

	addFile: function (data) {
		var file = data.full_file;
		BriefCaseV2.openDir(file.directorie);
	},

	deleteFile: function (fileId) {
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Attention!"),
			type: "warning",
			buttons: [
				{ text: Loc.g("Non"), click: function () { $(this).dialog("close"); return false; } },
                { text: Loc.g("Oui"), click: function () { BriefCaseV2.deleteFileCallback(fileId); $(this).dialog("close"); } }
            ]
		};
		MyWindow.alert(Loc.g("Supprimer le fichier ?"), options);
	},

	deleteFileCallback: function (fileId) {
		var params = new Object;
		params.fid = fileId;
		params.action = 'deletefile';
		MyFacture.post('uploadFile', params, function (data) {
			if (data.success === 'N') {
				Push.error(Loc.g("Le fichier n'est pas accessible"));
			} else {
				$('#file_' + fileId).closest('.one-item').remove();
			}
		}, 'json');
	},

	openDir: function (dirId) {
		MyFacture.startWait();

		MyFacture.post('briefcasev2', { dirid: dirId, action: 'openDir' }, function (data) {

			if ($('#folder_' + dirId).hasClass('nav-one')) {
				$('#folder_' + dirId).nextAll().remove();
			}

			$('#briefcase .current-container').html(data.folder_html);
			$('#briefcase .structure-container .opened-dir').removeClass('opened-dir');

			var folder = $('#briefcase .structure-container #folder_' + data.folder_object.id);
			folder.addClass('opened-dir').addClass('already-opened');
			folder.parent().parent().find('.structure-folders').remove();
			folder.parent().after(data.folder_structure_html);

			var groupedActionContainer = $('.cur-dir-grouped-action');
			groupedActionContainer.find('select option:selected').removeAttr('selected');
			groupedActionContainer.animate({ opacity: 0 }, 200);

			$('#briefcase .current-container input[type="checkbox"]').click(function () {
				var groupedActionOpacity = groupedActionContainer.css('opacity');
				var nbChecked = $('#briefcase .current-container .grouped-action-selector > label > input:checked').length;

				if ((groupedActionOpacity > 0 && nbChecked == 0) || (groupedActionOpacity == 0 && nbChecked > 0)) {
					groupedActionContainer.animate({ opacity: groupedActionOpacity > 0 ? 0 : 1 }, 200).find('select option:first').selected();
				}

			});

			BriefCaseV2.slideStructure(dirId, true);
			MyFacture.customForm();
			BriefCaseV2.initDragAndDrop();
			MyFacture.stopWait();
		}, 'json');
	},

	displayMoreDir: function (dirId, limitStart) {

		MyFacture.post('briefcasev2', { action: 'displayMoreDir', dirid: dirId, limitStart: limitStart }, function (data) {
			var json = $.parseJSON(data);
			$('#briefcase .moreRessources').remove();
			$('#briefcase .current-container').append(json.folder_html);
			MyFacture.customForm();
			BriefCaseV2.initDragAndDrop();
		});
	},

	openFile: function (fileId, extension) {

		var params = {
			fileid: fileId,
			action: 'openFile'
		};

		MyFacture.post('briefcasev2', params, function (data) {
			if (data.isAccessible) {

				const regex = new RegExp(/(gif|jpe?g|tiff?|png|webp|bmp|pdf)$/i)

				if (regex.test(extension) === true) {
					window.open(`${data.filePublicPath}&display=Y`, '_blank');
				}
				else {
					window.location = data.filePublicPath;
				}

			} else {
				Push.error(Loc.g("Le fichier n'est pas accessible"));
			}
		}, 'json');

	},

	copyLink: function (fileId) {
		var params = new Object;
		params.fileid = fileId;
		params.action = 'openFile';
		MyFacture.post('briefcasev2', params, function (data) {
			window.prompt(Loc.g("Lien public de votre fichier"), data.filePublicPath);
		}, 'json');
	},

	editDir: function (dirId, isNew) {

		var isNew = isNew !== undefined;

		var options = {
			title: (isNew ? Loc.g("Créer un dossier") : Loc.g("Modifier le dossier")),
			width: 440,
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				}, {
					text: Loc.g("Enregistrer"),
					click: function () {
						$("#createDirForm").submit();
					}
				}
			],
			callback: function () {
				BriefCaseV2.preapreCreateDir();
			}
		};

		var datas = { action: "createDirForm" };

		if (isNew) {
			datas.parentid = dirId;
		} else {
			datas.dirId = dirId;
		}

		MyWindow.load("briefcasev2", datas, options);
	},
	preapreCreateDir: function () {
		var formId = "createDirForm";
		var options = { success: function (data) { BriefCaseV2.createDirCallback(data); }, dataType: "json" };
		var params = { 'action': 'createDir' };
		MyForm.prepare(formId, 'briefcasev2&' + $.param(params), options, true);
		$("#createDir_privilege").change(function () {
			if ($(this).find('option:selected').val() == "custom") {
				$("#createDirForm .collab-container").fadeIn();
			} else {
				$("#createDirForm .collab-container").fadeOut();
			}
		});
		MyFacture.initEvent();
	},

	createDirCallback: function (data) {
		var formIsOk = MyForm.processJson(data, "createDirForm");
		if (formIsOk) {
			if (data.succes == 'Y') {
				switch (data.type) {
					case "create":
						$('#briefcase .current-container').html(data.folder_html);
						var newObj = data.folder_new;
						var testStructure = $('.structure-container #folder_' + newObj.parentid).closest('.structure-folder');
						if (testStructure.find('.structure-folders').length == 0) {
							testStructure.find('.spacer').removeClass('spacer').addClass('briefcase-toggler-close');
							testStructure.find('.structure-folder-title').after('<ul class="structure-folders" style="margin-left: 7px; display: block;"></ul>');
						}
						var newHTml = '';
						newHTml += "<li class='structure-folder'><div class='structure-folder-title one-droppable'><a href='javascript:;' onClick='BriefCaseV2.slideStructure(" + newObj.id + ", false)' class='spacer'></a><img src='/ressources/logged/img/classeur/folder.png' /><a id='folder_" + newObj.id + "' href='javascript:;' class='structure-folder-name root-folder' onClick='BriefCaseV2.openDir(" + newObj.id + ")' >" + newObj.name + "</a></div></li>";
						testStructure.find('.structure-folders:first').append(newHTml);
						break;
					case "edit":
						var editObj = data.folder_edit;
						$('.structure-container #folder_' + editObj.id).html(editObj.name);
						$('.current-container #folder_' + editObj.id).html(editObj.name);
						break;
				}
				BriefCaseV2.initDragAndDrop();
				MyFacture.customForm();
			} else if (data.isAccessible === 'N') {
				Push.error(Loc.g("Vous n'avez pas les permissions requises."));
			} else {
				MyWindow.alert(Loc.g("Un dossier portant ce nom existe déjà. Veuillez choisir un autre nom."), { 'type': 'error' });
			}
			MyWindow.close();
		}
	},

	searchInDir: function (me) {
		var search = me.val();
		if (search.length >= 3) {
			$("#briefcase .one-item .name .one-item-link:not(:contains('" + search + "'))").closest('.one-item').hide();
		} else if (search.length == 0) {
			$('#briefcase .one-item').show();
		}
	},

	cannotEdit: function () {
		MyWindow.alert(Loc.g("Vous ne pouvez pas modifier les propriétés d'un dossier/fichier qui ne vous appartient pas !"), { type: 'error' });
	}

};

window.BriefcaseTab = {

	loadBriefcaseTab: function (linkedtype, linkedtypeDir, linkedid, linkedname, editpermission) {

		var briefcaseContent = '#content_briefcase';

		$(briefcaseContent).html(MyWindow.getLoader());

		var options = {
			action: "loadBriefcaseTab",
			linkedid: linkedid,
			linkedtype: linkedtype,
			linkedtypeDir: linkedtypeDir,
			linkedname: linkedname,
			editpermission: editpermission,
		};

		MyFacture.post('briefcasev2', options, function (data) {
			$(briefcaseContent).html(data.listing);
			BriefCaseV2Light.init();
			MyFacture.customForm(briefcaseContent);
		}, 'json');
	}
};
